const cardsData = [
  {
    title: '不可错过的十部悬疑神作',
    tag: '编辑推荐',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20aesthetic%20with%20dramatic%20shadow%20and%20light%20interplay%2C%20detective%20theme%20visual%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20cinematic%20noir%20style%2C%20professional%20film%20photography&width=600&height=400&seq=cards-01&orientation=landscape',
    desc: '从国产经典到进口佳作，十部让你猜不到结局的悬疑电影，每一部都值得二刷。',
  },
  {
    title: '2026暑期档观影全攻略',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20entrance%20with%20movie%20posters%20display%2C%20warm%20golden%20hour%20lighting%2C%20theater%20marquee%20glowing%2C%20cinematic%20atmosphere%2C%20professional%20movie%20theater%20photography%2C%20rich%20amber%20tones&width=600&height=400&seq=cards-02&orientation=landscape',
    desc: '院线大片、平台独播、经典重温，一份攻略在手，整个暑假看片不愁。',
  },
  {
    title: '那些年我们追过的TVB经典',
    tag: '怀旧专题',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20TV%20drama%20nostalgic%20visual%20with%20old%20television%20set%20and%20vintage%20photos%2C%20warm%20faded%20color%20tones%2C%20nostalgic%20cinematic%20mood%2C%20professional%20vintage%20photography%20style&width=600&height=400&seq=cards-03&orientation=landscape',
    desc: '《射雕英雄传》《大时代》《刑事侦缉档案》...那些陪伴我们成长的港剧经典。',
  },
  {
    title: '国漫崛起：精品动画盘点',
    tag: '动漫频道',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20visual%20with%20ink%20wash%20painting%20elements%20and%20modern%20anime%20technique%2C%20beautiful%20gradient%20colors%2C%20cinematic%20lighting%2C%20professional%20illustration%20quality%2C%20dark%20elegant%20background&width=600&height=400&seq=cards-04&orientation=landscape',
    desc: '从《大圣归来》到《哪吒》，国漫正在用实力证明自己的高度。',
  },
  {
    title: '纪录片爱好者必看清单',
    tag: '知识频道',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20filmmaking%20aesthetic%20with%20camera%20equipment%20and%20nature%20elements%2C%20professional%20cinematography%20vibe%2C%20warm%20earth%20tones%2C%20dramatic%20natural%20lighting%2C%20adventure%20exploration%20theme&width=600&height=400&seq=cards-05&orientation=landscape',
    desc: '豆瓣9分以上的顶级纪录片合集，打开新世界的大门从这里开始。',
  },
  {
    title: '周末刷剧指南：轻松喜剧精选',
    tag: '轻松一刻',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20popcorn%20and%20soft%20blanket%2C%20warm%20comfortable%20lighting%2C%20TV%20screen%20glowing%2C%20relaxing%20weekend%20vibe%2C%20professional%20interior%20photography%2C%20golden%20warm%20atmosphere&width=600&height=400&seq=cards-06&orientation=landscape',
    desc: '工作一周辛苦了！这份轻松喜剧片单专为你的周末放松时光准备。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">精选推荐</h2>
          <p className="text-foreground-400 text-sm">编辑团队为你精心挑选的优质内容与观影指南</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[1100px] mx-auto">
          {cardsData.map((item, i) => (
            <div key={i} className="group cursor-pointer rounded-xl overflow-hidden bg-background-100 border border-background-300/40 hover:border-primary-500/30 transition-all duration-300">
              <div className="relative overflow-hidden aspect-[3/2]">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" width="600" height="400" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-950/70 text-secondary-400 border border-secondary-500/30 whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-bold text-foreground-50 text-base group-hover:text-primary-400 transition-colors mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-400 leading-relaxed">{item.desc}</p>
                <div className="mt-4 flex items-center gap-1.5 text-primary-400 text-sm font-medium">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}